export default {
	gaKey: "UA-12737366-4"
};



// WEBPACK FOOTER //
// ./src/config/dev.js